import React from "react";
// import CV from "../../assest/Fortune-Oliseyenum-Resume.pdf";
import CV from "../../assets/Fortune-Oliseyenum-Resume.pdf";

const CTA = () => {
  return (
    <div className="cta">
      <a href={CV} download className="btn">
        Download Cv
      </a>
      <a href="#contact" className="btn btn-primary">
        Let's Talk
      </a>
    </div>
  );
};

export default CTA;
